import {
    Button, Form, Input, Modal,
} from 'antd';
import { useState } from 'react';
import { useApiFetch } from '../../hooks/api/useApiFetch';

const AvitoAttachPhoneModal = ({ id, phone, onUpdated }: { id: number; phone?: string | null; onUpdated: () => void; }) => {
    const api = useApiFetch();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const hide = () => setVisible(false);

    const show = () => setVisible(true);

    const onFinish = async () => {
        setLoading(true);
        await api.fetchData(`/avito-chats/${id}/phone`, 'post', true, { phone: form.getFieldValue('phone') || null });
        if (typeof onUpdated === 'function') {
            onUpdated();
        }
        hide();
        setLoading(false);
    };

    return (
        <>
            <Modal
                visible={visible}
                onCancel={hide}
                okButtonProps={{ loading, onClick: form.submit }}
                okText="Сохранить"
                title="Прикрепить номер телефона"
            >
                <Form form={form} onFinish={onFinish}>
                    <Form.Item name="phone">
                        <Input allowClear defaultValue={phone || undefined} />
                    </Form.Item>
                </Form>
            </Modal>
            <Button type="primary" onClick={show}>Прикрепить номер телефона</Button>
        </>
    );
};

AvitoAttachPhoneModal.defaultProps = {
    phone: undefined,
};

export default AvitoAttachPhoneModal;
